import i18next from "i18next";
import { detectLang } from "src/common/detectLang";
import { PageUrl } from "./PageUrl";

type QueryParams = Record<string, number | string | null | undefined>;

const escapeRegExp = (value: string) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const replaceRouteParams = <T extends {}>(url: string, params?: T) => {
  if (!params) return url;

  return Object.entries(params).reduce(
    (result, [key, value]) =>
      result.replace(
        new RegExp(`:${escapeRegExp(key)}\\??`, "g"),
        String(value),
      ),
    url,
  );
};

const removeUnusedOptionalParams = (url: string) =>
  url.replace(/\/:[^/]+\?/g, "");

const makeQueryString = (query?: QueryParams) => {
  if (!query) return "";

  return Object.entries(query)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(([key, value]) => `${key}=${encodeURIComponent(value!)}`)
    .join("&");
};

const appendQuery = (url: string, query?: QueryParams) => {
  const queryString = makeQueryString(query);
  if (!queryString) return url;

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${queryString}`;
};

/**
 * Данная функция предназначена для формирования урлов в пределах приложения для использования в <Link to=... />
 * @param urlId
 * @param params
 * @returns
 */
export const makeUrl = <T extends {} = {}>(
  urlId: PageUrl,
  params?: T,
  query?: QueryParams,
): string => {
  const url = appendQuery(
    removeUnusedOptionalParams(replaceRouteParams(`${urlId}`, params)),
    query,
  );

  return `/${i18next.language || detectLang()}${url}`;
};
